import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import BreakpointProvider from '../BreakpointProvider';
import CategoryNavigationList from '../CategoryNavigationList';
import useFetchLocalNavQuery from '../CategoryRailNavigation/hooks/useFetchLocalNavQuery';
import FacetAndCategoryToaster from '../FacetAndCategoryToaster';
import { LOADING_MESSAGE } from '../Messages/Messages';
import PillButton from '../PillButton';
import style from './CategoriesToaster.module.scss';

const CategoriesToaster = ({ categoryId, productCount }) => {
  const [toasterState, setToasterState] = useState({
    isOpen: false,
  });
  const {
    loading, error, categoryData,
  } = useFetchLocalNavQuery(categoryId, true);

  const openToaster = useCallback(() => {
    setToasterState((prevState) => ({
      ...prevState,
      isOpen: true,
    }));
  }, []);

  if (loading) {
    return LOADING_MESSAGE;
  }

  // Per team discussion, show nothing instead of error content/text in this case
  if (error || !categoryData?.localNavigation?.displayTypes) {
    return null;
  }
  const { localNavigation } = categoryData;

  const iconOptions = {
    name: (toasterState.isOpen) ? 'up-thin' : 'down-thin',
    position: 'right',
  // labelText: TODO: use TMNT for labelText prop
  };

  return (
    <>
      <PillButton
        clickHandler={openToaster}
        iconOptions={iconOptions}
        name={`${categoryData?.dropdownTopValue} ${productCount ? `(${productCount})` : ''}`}
      />
      <BreakpointProvider>
        <FacetAndCategoryToaster
          setToasterState={setToasterState}
          toasterHeadingLabel={localNavigation.headingLabel}
          toasterState={toasterState}
        >
          <div className={classNames(style.categoryList, 'scope-1892')}>
            <CategoryNavigationList
              localNavigation={localNavigation}
              variant="toaster"
            />
          </div>
        </FacetAndCategoryToaster>
      </BreakpointProvider>
    </>
  );
};

export default CategoriesToaster;

CategoriesToaster.propTypes = {
  categoryId: PropTypes.string.isRequired,
  productCount: PropTypes.number,
};
